import React, { useState } from 'react';

import TextField from '@material-ui/core/TextField';

function InputMessage({ sendMessage, is_closed }) {
  const [message_input, setMessage_input] = useState('');

  return (
    <>
      <TextField
        fullWidth
        autoFocus
        disabled={is_closed}
        value={message_input}
        label="Digite uma mensagem"
        variant="outlined"
        onChange={(event) => {
          setMessage_input(event.target.value);
        }}
        InputProps={{
          onKeyPress: (e) => {
            if (e.key === 'Enter') {
              sendMessage(message_input);
              setMessage_input('');
            }
          },
        }}
      />
    </>
  );
}

export default InputMessage;
